import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Home from "./Page/Home/HomePage";
import About from "./Page/About/AboutPage";
import Contact from "./Page/Contact/ContactPage";
// import Sustainability from "./Page/Sustainability/SustainabilityPage";
import Packaging from "./Page/Packaging/Packaging";


/* Product Sections */
import DrinkWater from "./Page/Products/DrinkWater/DrinkWater";
import Fireproof from "./Page/Products/Fireproof/Fireproof";
import Sealing from "./Page/Products/Sealing/Sealing";
import Special from "./Page/Products/Special/Special";
import Vibration from "./Page/Products/Vibration/Vibration";
/* Technologies Sections*/
import Automation from "./Page/Technologies/Automation/Automation";
import Material from "./Page/Technologies/Material/Material";
import MixingProcess from "./Page/Technologies/MixingProcess/MixingProcess";
/* Quality Sections */
import QualityControl from "./Page/Quality/QualityControl/QualityControl";
import QualitAssurance from "./Page/Quality/QualityAssurance/QualityAssurance";
import Loading from "./Components/Loading/Loading";

import { useState,useEffect} from 'react';
function App() {
  const location = useLocation();

  const [loading,setLoading]= useState(true)
  useEffect(()=>{
    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    },1000)
  },[location.pathname])
  return (
    <div className="App">
      <Navbar location={location.pathname}/>
      
      <Routes>
        <Route path="/" element={loading ? <Loading/> :<Home />} />
        <Route path="/about" element={loading ? <Loading/> :<About />} />
        <Route path="/drinkwater" element={loading ? <Loading/> :<DrinkWater />} />
        <Route path="/fireproof" element={loading ? <Loading/> :<Fireproof />} />
        <Route path="/sealing" element={loading ? <Loading/> :<Sealing />} />
        <Route path="/special" element={loading ? <Loading/> :<Special />} />
        <Route path="/vibration" element={loading ? <Loading/> :<Vibration />} />
        <Route path="/packaging" element={loading ? <Loading/> :<Packaging />} />
        <Route path="/automation" element={loading ? <Loading/> :<Automation/>} />
        <Route path="/material" element={loading ? <Loading/> :<Material/>} />
        <Route path="/mixingprocess" element={loading ? <Loading/> :<MixingProcess/>} />
        <Route path="/qualitycontrol" element={loading ? <Loading/> :<QualityControl/>} />
        <Route path="/qualitassurance" element={loading ? <Loading/> :<QualitAssurance/>} />
        {/* <Route path="/sustainability" element={<Sustainability />} /> */}
        <Route path="/contact" element={loading ? <Loading/> :<Contact />} />
      </Routes>
      <Footer location={location.pathname} />
    </div>
  );
}

export default App;
